var styles = {
  center: {
    minWidth: '60%',
    height: 40
  },
  pagination: {
    display: 'inline-block',
    padding: 0,
    margin: 0,
    fontSize: 15,
    listSyleType: 'none'
  },
  item: {
    display: 'inline',
    color: 'black',
    float: 'left',
    textDecoration: 'none'
  },
  arrow: {
    width: 40,
    height: 35,
    textDecoration: 'none',
    transition: 'background-color .3s',
    cursor: 'pointer',
    '$.active': {
      backgroundColor: '#334058',
      color: 'white'
    },
    '&:hover:not(.active)': {
      backgroundColor: '#ddd'
    }
  },
  blank: {
    width: 40,
    padding: 8
  },
  results: {
    fontSize: 16,
    padding: '8px 0 0 0',
    margin: '0 14px 0 0',
    textAlign: 'right'
  },
  number: {
    width: 40,
    padding: 8,
    textDecoration: 'none',
    transition: 'backgroundColor .3s',
    cursor: 'pointer',
    '$.active': {
      backgroundColor: '#334058',
      color: 'white'
    },
    '&:hover:not(.active)': {
      backgroundColor: '#ddd'
    }
  },
  ell: {
    width: 20,
    height: 15,
    textDecoration: 'none',
    margin: '15px 10px 0px 10px'
  },
  active: {
    backgroundColor: '#334058',
    color: 'white'
  }
};
export default styles;